import { createSlice } from "@reduxjs/toolkit";
import { convertKeysToCamelCase } from "@utils/utils";

const initialState = {
  branchId: 0,
  branchInfo: {},
  data: {},
};

const current = createSlice({
  name: "current",
  initialState: initialState,
  reducers: {
    switchCurrentBranch(store, action) {
      const { branchId, branchInfo } = action.payload;
      store.branchId = branchId;
      store.branchInfo = branchInfo;
    },
  },
});

export const { switchCurrentBranch } = current.actions;

export default current.reducer;
